import { ReactNode, createContext, useMemo } from 'react';
import { SegmentProvider } from 'components/filter/filters-next/SegmentContext';
import { FilterCacheKey } from 'types/filter-cache-key';

interface FilterProviderProps extends IFilterProvider {
    children: ReactNode;
}

interface IFilterProvider {
    resource: FilterCacheKey;
    cacheKey: FilterCacheKey;
    readOnly?: boolean;
}

const FilterProviderContext = createContext<IFilterProvider>({
    resource: 'contacts',
    cacheKey: 'contacts',
    readOnly: false,
});

const FilterProvider = (props: FilterProviderProps) => {
    const { resource, cacheKey, children, readOnly } = props;

    const ctx = useMemo(
        () => ({
            resource,
            cacheKey,
            readOnly,
        }),
        [cacheKey, resource, readOnly],
    );

    return (
        <FilterProviderContext.Provider value={ctx}>
            <SegmentProvider>{children}</SegmentProvider>
        </FilterProviderContext.Provider>
    );
};

export { FilterProvider, FilterProviderContext };
export type { IFilterProvider, FilterProviderProps };
